export const exam = [
    {
        id: "E140523",
        examName: "Week Test",
        examDate: "13 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        key:1
    },
    {
        id: "E140522",
        examName: "Mothly Test",
        examDate: "27 May 2024",
        startTime: "09:30 AM",
        endTime: "11:00 AM",
        key:2
    },
    {
        id: "E140521",
        examName: "Chapter Wise Test",
        examDate: "05 Jun 2024",
        startTime: "09:30 AM",
        endTime: "10:30 AM",
        key:3
    },
    {
        id: "E140520",
        examName: "Unit Test",
        examDate: "15 Jun 2024",
        startTime: "10:30 AM",
        endTime: "11:30 AM",
        key:4
    },
    {
        id: "E140519",
        examName: "Progress Test",
        examDate: "20 Jun 2024",
        startTime: "11:00 AM",
        endTime: "12:00 PM",
        key:5
    },
    {
        id: "E140518",
        examName: "Oral Test",
        examDate: "03 Jul 2024",
        startTime: "12:30 PM",
        endTime: "01:30 PM",
        key:6
    },
    {
        id: "E140517",
        examName: "Semester Exam",
        examDate: "18 Jul 2024",
        startTime: "10:30 AM",
        endTime: "12:30 PM",
        key:7
    },
    {
        id: "E140516",
        examName: "Quaterly Exam",
        examDate: "26 Aug 2024",
        startTime: "09:00 AM",
        endTime: "12:00 PM",
        key:8
    },
    {
        id: "E140515",
        examName: "Half Yearly Exam",
        examDate: "15 Nov 2024",
        startTime: "09:30 AM",
        endTime: "12:30 PM",
        key:9
    },
    {
        id: "E140514",
        examName: "Annual Exam",
        examDate: "10 Mar 2025",
        startTime: "10:00 AM",
        endTime: "01:00 PM",
        key:10
    }
];
